var _ellipse, _ellipse2, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 24.9683,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_15770_184749)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 24.9683,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_15770_184749)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12.5,
    r: 12.5,
    fill: "#019DF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7891 12.7083C18.7911 13.4783 18.6112 14.2378 18.2641 14.925C17.8525 15.7485 17.2198 16.4412 16.4367 16.9254C15.6537 17.4096 14.7514 17.6663 13.8307 17.6667C13.0608 17.6687 12.3013 17.4888 11.6141 17.1417L8.28906 18.25L9.3974 14.925C9.05027 14.2378 8.87039 13.4783 8.8724 12.7083C8.87275 11.7877 9.12942 10.8853 9.61365 10.1023C10.0979 9.31931 10.7905 8.68658 11.6141 8.275C12.3013 7.92788 13.0608 7.74799 13.8307 7.75H14.1224C15.3383 7.81708 16.4867 8.33028 17.3477 9.19134C18.2088 10.0524 18.722 11.2008 18.7891 12.4167V12.7083Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15770_184749",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 24.9683) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15770_184749",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 24.9682) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesActive);
export default __webpack_public_path__ + "static/media/messages-active.98645cb7c064291452a127ea18efcd05.svg";
export { ForwardRef as ReactComponent };